module.exports = __webpack_public_path__ + "assets/img/18_919.46b8ba9f.jpg";